import { useJsonLd } from './seo';
import { i18n } from './i18n';

const SITE = 'https://www.otopieces.com';
const API = process.env.REACT_APP_BACKEND_URL;

// Site-wide Organization (knowledge panel, logo in results) + WebSite with SearchAction (sitelinks search box).
export const useOrganizationJsonLd = (company) => {
  const c = company || {};
  const sameAs = [c.facebook_url, c.instagram_url, c.tiktok_url].filter(Boolean);
  useJsonLd('organization', {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': ['Organization', 'OnlineStore'],
        '@id': `${SITE}/#organization`,
        name: c.name || 'OTOPIECES.COM',
        url: SITE,
        logo: { '@type': 'ImageObject', url: c.logo_url ? (c.logo_url.startsWith('/') ? `${API}${c.logo_url}` : c.logo_url) : `${API}/api/branding/icon-512.png` },
        image: `${API}/api/branding/og-image`,
        description: i18n.get() === 'fr' && c.og_tagline ? c.og_tagline : i18n.t('seo.defaultDesc'),
        ...(c.email ? { email: c.email } : {}),
        ...(c.phone ? { telephone: c.phone } : {}),
        ...(c.siret ? { identifier: { '@type': 'PropertyValue', name: 'SIRET', value: c.siret } } : {}),
        ...(c.address ? { address: { '@type': 'PostalAddress', streetAddress: c.address, postalCode: c.postal_code, addressLocality: c.city, addressCountry: 'FR' } } : {}),
        ...(c.phone ? { contactPoint: [{ '@type': 'ContactPoint', telephone: c.phone, contactType: 'customer service', availableLanguage: ['French', 'English', 'German', 'Spanish', 'Italian'], areaServed: 'FR' }] } : {}),
        ...(sameAs.length ? { sameAs } : {}),
      },
      {
        '@type': 'WebSite',
        '@id': `${SITE}/#website`,
        url: SITE,
        name: c.name || 'OTOPIECES.COM',
        inLanguage: 'fr-FR',
        publisher: { '@id': `${SITE}/#organization` },
        potentialAction: {
          '@type': 'SearchAction',
          target: { '@type': 'EntryPoint', urlTemplate: `${SITE}/recherche?q={search_term_string}` },
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  });
};
